const SUBJECT_MAP = {
  0: 'UNKNOWN',
  101: 'CHINESE',
  102: 'MATH',
  103: 'ENGLISH',
  104: 'PHYSICS',
  105: 'CHEMISTRY',
  106: 'BIOLOGY',
  107: 'POLITICS',
  108: 'GEOGRAPHY',
  109: 'HISTORY',
  110: 'INFORMATION',
  111: 'HISTORY_SOCIETY',
  112: 'SCIENCE',
  113: 'GENERIC_TECHNOLOGY',
  114: 'ENCYCLOPEDIA',
  115: 'PHYSICAL_EDUCATION',
  116: 'ART',
  117: 'MUSIC',
  118: 'COMP_PRACTICE',
  119: 'FRENCH',
  120: 'JAPANESE',
  121: 'RUSSIAN',
  122: 'OTHER1',
  123: 'OTHER2',
  124: 'MORAL_EDUCATION',
  125: 'MORALITY_AND_LEGALITY',
  126: 'LABOR_SKILLS',
  127: 'EXPLORATION',
  128: 'NATURE',
  129: 'SOCIETY',
  130: 'CALLIGRAPHY',
  131: 'HOUSEHOLD_LIFE_GUIDANCE',
  132: 'MENTAL_HEALTH',
  133: 'PSYCHOLOGICAL_COUNSELING',
  134: 'TECHNOLOGICAL_INNOVATION',
  135: 'LABOUR_EDUCATION',
  136: 'CASE_ANALYSIS',
  202: 'MATH',
  201: 'CHINESE',
  203: 'ENGLISH',
  204: 'PHYSICS',
  205: 'CHEMISTRY',
  206: 'BIOLOGY',
  207: 'POLITICS',
  208: 'GEOGRAPHY',
  209: 'HISTORY',
  301: 'CHINESE',
  302: 'MATH',
  303: 'ENGLISH',
  304: 'PHYSICS',
  305: 'CHEMISTRY',
  306: 'BIOLOGY',
  307: 'POLITICS',
  308: 'GEOGRAPHY',
  309: 'HISTORY',
  1000: 'ALL'
}
const TERM_MAP = [
  {
    name: '上册',
    value: 1
  },
  {
    name: '下册',
    value: 2
  }
]

const BASE_GRADES = [
  {
    name: '一年级',
    value: 1
  },
  {
    name: '二年级',
    value: 2
  },
  {
    name: '三年级',
    value: 3
  },
  {
    name: '四年级',
    value: 4
  },
  {
    name: '五年级',
    value: 5
  },
  {
    name: '六年级',
    value: 6
  },
  {
    name: '七年级',
    value: 7
  },
  {
    name: '八年级',
    value: 8
  },
  {
    name: '九年级',
    value: 9
  },
  {
    name: '高一',
    value: 11
  },
  {
    name: '高二',
    value: 12
  },
  {
    name: '高三',
    value: 13
  }
]

export { SUBJECT_MAP, TERM_MAP, BASE_GRADES }
